const secondary = "#7BC57F"
const primary = "#000000"
const secondaryHover = "#66AF6A"
const primaryHover = "#3B3A3D"
const secondaryDisabled = "rgba(102, 175, 106, 0.5)"
const primaryDisabled = "#AEAEAE"
/* Declare Styles */
export default theme => ({
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: 0,
    marginRight: 0,
    padding: 0,
    backgroundColor: '#F8FCFF',
    [theme.breakpoints.up(443 + theme.spacing(3) * 2)]: {
      width: 443,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    //padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
    padding: `30px 25px 40px 25px`,
    boxShadow: '0 7px 19px 6px rgba(204, 216, 225, 0.14);',
    [theme.breakpoints.down(443 + theme.spacing(3) * 2)]: {
      marginTop: 0,
      minHeight: '100vh',
    },
  },
  avatar: {
    //marginTop: '8px',
    width: '60px',
    height: '60px',
    float: 'right',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  submit: {
    marginTop: theme.spacing(3),
  },
  headerText: {
    width: '100%',
    color: '#000000',
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '53px',
  },
  headerBorder: {
    borderBottom: '1px solid #DDDDDD',
    marginBottom: '20px',
  },
  headerMainBorder: {
    borderBottom: '2px solid ' + secondary,
    width: '50%',
    marginBottom: '-1.01px',
  },
  headerMonthlyBorder: {
    marginLeft: '50%',
  },
  studentName: {
    width: '100%',
    color: '#2C2C2C',
    fontSize: '16px',
    lineHeight: '23px',
    fontWeight: '700',
  },
  campaignName: {
    width: '100%',
    color: '#A0A1B0',
    lineHeight: '19px',
    fontSize: '16px',
    fontWeight: '500',
  },
  campaignDonations: {
    width: '100%',
    color: '#6D8291',
    lineHeight: '17px',
    fontSize: '14px',
    fontWeight: '600',
    marginTop: '11px',
  },
  campaignInformationWrapperName: {
    marginTop: '14px',
    padding: '8px 0px',
  },
  stepActive: {
    display: 'block',
  },
  stepInactive: {
    display: 'none',
  },
  button: {
    //marginLeft: '9px',
    width: 'calc(100% - 4px)',
    backgroundColor: primary,
    borderRadius: '0px',
    height: '60px',
    color: '#fff',
    fontSize: '18px',
    lineHeight: '22px',
    fontWeight: 700,
    marginTop: '20px',
    '&:hover': {
      backgroundColor: primaryHover,
    },
    '&:disabled': {
      backgroundColor: primaryDisabled + '!important',
    },
  },
  buttonAlt: {
    //marginLeft: '9px',
    width: 'calc(100% - 4px)',
    backgroundColor: secondary,
    borderRadius: '0px',
    height: '60px',
    color: '#fff',
    fontSize: '18px',
    lineHeight: '22px',
    fontWeight: 700,
    marginTop: '8px',
    '&:hover': {
      backgroundColor: secondaryHover,
    },
    '&:disabled': {
      backgroundColor: secondaryDisabled,
      color: '#fff',
    },
  },
  amountButton: {
    backgroundColor: '#F7F7F7',
    border: '1px solid #C4CAD3 !important',
    //width: '110px',
    height: '60px',
    color: '#6A6A6A',
    fontSize: '21px',
    lineHeight: '53px',
    opacity: '0.5777529761904762',
    marginTop: '24px',
    fontWeight: 600,
    borderRadius: '10px',
  },
  amountButtonSelected: {
    backgroundColor: secondary,
    color: '#fff',
    opacity: 1,
    '&:hover': {
      backgroundColor: secondaryHover,
    },
  },
  amountOther: {
    //marginTop: '24px',
    backgroundColor: '#F7F7F7',
    //width: '245px',
  },
  amountOtherInput: {
    fontSize: '21px',
  },
  amountOtherLabel: {
    color: '#9093A2',
    fontSize: '16px',
    fontWeight: 600,
  },
  amountOtherNotchedOutline: {
    borderColor: '#e0e3e5',
  },
  giveInHonorText: {
    color: '#6A6A6A',
    marginLeft: '5px',
    cursor: 'pointer',
    float: 'left',
    transition: 'all 0.2s',
  },
  amountOtherRoot: {
    height: '60px',
    borderRadius: '10px',
    fontSize: '16px',
  },
  coverProcessingFees: {
    marginTop: '24px',
    marginLeft: '7px',

  },
  coverProcessingFeesText: {
    color: '#6A6A6A',
  },
  totalAmountText: {
    fontSize: '16px',
    lineHeight: '19px',
    marginTop: '42px',
    color: "#6a6a6ac7",
    marginRight: '4px',
  },
  totalAmount: {
    color: '#2C2C2C',
    fontWeight: "bold"
  },
  dedicationFields: {
    borderRadius: '0px',
    marginBottom: 0,
  },
  dedicationFieldsWarper: {
    marginTop: '16px',
  },
  dedicationLabel: {
    fontSize: '14px',
    //lineHeight: '17px',
    color: 'rgba(106, 106, 106, 0.66)',
  },
  anonymous: {
    //marginTop: '32px',
    marginTop: '6px',
    marginBottom: '4px',
  },
  cardWrapper: {
    marginTop: '8px',
    marginBottom: '61px',
  },
  doneHeader: {
    color: '#000000',
    fontSize: '30px',
    lineHeight: '53px',
    fontWeight: 700,
  },
  doneSubheader: {
    color: '#919191',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '25px',
  },
  doneContainer: {
    padding: '20px 20px',
  },
  cardTitle: {
    fontWeight: 600,
    fontSize: '16px',
    color: '#2C2C2C',
    marginBottom: '8px',
  },
  postSeedButton: {
    color: secondary,
    textTransform: 'none',
    marginTop: '8px',
    backgroundColor: primary,
    borderRadius: '0px',
    color: '#fff',
    '&:hover': {
      backgroundColor: primaryHover,
    },
    '&:disabled': {
      backgroundColor: primaryDisabled + '!important',
    },
  },
  sharerCont: {
    marginTop: '20px',
  },
  sharerTitle: {
    color: '#A5B4C0',
    fontWeight: 600,
    fontSize: '16px'
  },

  enterDetailsText: {
    display: 'flex',
    fontSize: '14px',
    '&::before': {
      background: '#dfdfd7',
      flex: '1 1',
      height: '1px',
      content: '""',
      alignSelf: 'center',
      marginRight: '10px'
    },
    '&::after': {
      background: '#dfdfd7',
      flex: '1 1',
      height: '1px',
      content: '""',
      alignSelf: 'center',
      marginLeft: '10px'
    },
  }
});
